import { createSlice } from '@reduxjs/toolkit';

export const createInitialAccountInfoState = () => ({
        email: null,
        timeExpire: null,
});

export const accountInfoSlice = createSlice({
    name: 'accountInfo',
    initialState: createInitialAccountInfoState(),
    reducers: {
        setEmail: (state, action) => {
            state.email = action.payload
        },
        setExpireTimeOTP: (state, action) => {
            state.timeExpire = action.payload
        },
        setNullAccountInfo: () => createInitialAccountInfoState(),
    }
})
export const { setEmail, setExpireTimeOTP, setNullAccountInfo } = accountInfoSlice.actions;
export default accountInfoSlice.reducer;
